export default "__VITE_PUBLIC_ASSET__9f35fe29__"